var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tag-input/~/lodash/_nativeCreate.js
 ** module id = 1136
 ** module chunks = 0
 **/